/* =========================================
   LABORATORY QUALITY SECTION JS
   Premium Animation + Counter
========================================= */


document.addEventListener("DOMContentLoaded", function(){



/* =========================================
   Scroll Reveal Animation
========================================= */


const labSection =
document.querySelector(".laboratory-quality");



if(labSection){


    const revealItems =
    labSection.querySelectorAll(
        ".lab-card, .lab-stat"
    );



    const observer =
    new IntersectionObserver(
        function(entries){


            entries.forEach(function(entry){


                if(entry.isIntersecting){


                    entry.target.classList.add(
                        "lab-visible"
                    );


                    observer.unobserve(
                        entry.target
                    );


                }


            });


        },
        {
            threshold:0.2
        }
    );



    revealItems.forEach(function(item){

        observer.observe(item);

    });


}





/* =========================================
   Animated Counter
========================================= */


const counters =
document.querySelectorAll(
".laboratory-quality .counter"
);



counters.forEach(function(counter){


    let started=false;


    const animateCounter=function(){


        if(started) return;


        started=true;


        const target =
        Number(
            counter.innerText
        );


        let current=0;


        const speed =
        Math.max(
            20,
            1500 / target
        );



        const update=function(){


            current += Math.ceil(
                target / 60
            );



            if(current >= target){


                counter.innerText =
                target;


                return;


            }



            counter.innerText =
            current;



            requestAnimationFrame(
                update
            );


        };


        update();


    };





    const counterObserver =
    new IntersectionObserver(
        function(entries){


            entries.forEach(function(entry){


                if(entry.isIntersecting){


                    animateCounter();


                    counterObserver.unobserve(
                        entry.target
                    );


                }


            });


        },
        {
            threshold:.5
        }
    );



    counterObserver.observe(counter);


});



});